export function homeResetBaseStateRequest() {
  return {
    type: '@home/RESET_BASE_STATE_REQUEST'
  }
}

export function homeResetBaseStateSuccess() {
  return {
    type: '@home/RESET_BASE_STATE_SUCCESS'
  }
}

export function homeResetBaseStateFailure() {
  return {
    type: '@home/RESET_BASE_STATE_FAILURE'
  }
}
